import {
  GOOGLE_ADS_CAMPAIGN_STATUS,
  GoogleAdsCampaignConnectionStatus,
} from '../../../../../../services/exports/Constants';

export default {
  title: 'Google Ads',
  search: {
    placeholder: 'Cerca per ID, nome o azienda',
  },
  filters: {
    connection_statuses: {
      placeholder: 'Stato connessione',
      options: {
        [GoogleAdsCampaignConnectionStatus.Connected]: 'Connesso',
        [GoogleAdsCampaignConnectionStatus.NotConnected]: 'Non connesso',
      },
    },
  },
  columns: {
    name: 'Nome',
    company: 'Azienda',
    connected: 'Connesso',
    action: 'Azione',
    details: 'Dettagli',
    address: 'Indirizzo',
    status: 'Stato',
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'Non specificato',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Attivo',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'In pausa',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Sconosciuto',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Rimosso',
  },
};
